<template>
  <div>
    <div class="fixed bottom-36 right-4 z-float-buttons">
      <button
        v-if="y > 100"
        class="mt-2 flex h-12 w-12 items-center justify-center rounded-full bg-blue-400 shadow-normal shadow-gray-400 hover:shadow-black/50 active:bg-blue-600 active:shadow-black/50"
        @click="handleScrollTo()"
      >
        <IconArrow class="h-5 w-5 text-white" direction="up" />
      </button>
    </div>
    <!--TODO: LiveChatbot 暫時隱藏-->
    <!-- <div v-show="!isCN" class="fixed bottom-20 right-4 z-float-buttons">
      <button
        v-show="isShowLiveChatButton && isLiveChatReady"
        id="tracking_dialogue"
        class="zendeskTrigger flex h-12 w-12 items-center justify-center rounded-full bg-blue-400 shadow-normal shadow-gray-400 hover:shadow-black/50 active:bg-blue-600 active:shadow-black/50"
        @click="handleClick"
      >
        <IconLiveChat class="h-5 w-5 text-white" />
      </button>
    </div> -->
    <div v-show="isCN" class="fixed bottom-20 right-4 z-float-buttons">
      <TheNuxtLink
        id="tracking_dialogue"
        class="flex h-12 w-12 items-center justify-center rounded-full bg-blue-400 shadow-normal shadow-gray-400 hover:shadow-black/50 active:bg-blue-600 active:shadow-black/50"
        to="https://wpa1.qq.com/p2kDuAV4?_type=wpa&qidian=true"
      >
        <img
          src="@/assets/images/chatbot-qq.webp"
          alt="chatbot icon"
          loading="lazy"
          class="pointer-events-none block h-10 w-10 object-contain"
        />
      </TheNuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
  const { isCN } = useLanguage();

  // const mainStore = useMainStore();
  // const { isLiveChatReady } = storeToRefs(mainStore);
  const { y } = useScrollValue();
  const { handleScrollTo } = useScrollTo();

  // const isShowLiveChatButton = ref<boolean>(true);

  // const handleClick = (): void => {
  //   window.gtag('event', 'site_click', { Item: '開啟Chatbox對話' });
  //   isShowLiveChatButton.value = false;
  // };
</script>

<style lang="scss">
  .embeddedMessagingConversationButtonWrapper {
    .embeddedMessagingConversationButton {
      bottom: 80px !important;
      right: 16px !important;
      width: 48px !important;
      height: 48px !important;
      background: #006eff !important;

      &:not(.no-hover):hover {
        opacity: 1 !important;
        background: #006498 !important;
      }
    }
    .embeddedMessagingLoadingSpinner {
      margin: 0px !important;
      padding-inline-start: 0px !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }
  }

  .embeddedMessagingFrame,
  .embeddedMessagingConversationButtonWrapper {
    z-index: 10000 !important;
  }
</style>
